"use client";

import React from "react";
const partners = [{
  name: "Syed Natif Nawaz",
  focus: "Technical Execution & Infrastructure Underwriting",
  line1: "120+ Global DCs • $7.6B M&A • 5 Patents",
  line2: "$400M+ VC AUM • LP Networks"
}, {
  name: "Narsi Ayyagari",
  focus: "Fund Operations, LP Governance & Capital Deployment",
  line1: "$1B+ PE Fund COO • 25+ Yrs PE/VC",
  line2: "Tech Founder/CEO • India/APAC Access • $400M+ VC GP"
}];
export default function PartnerCapabilitiesSection() {
  return <section className="relative overflow-hidden bg-[#FDFAF3] py-12 text-[#1C1917]">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="overflow-hidden rounded-xl border border-[#D8C29A] bg-[#F5EDD8] shadow-sm">
          <div className="h-1 bg-[#B45309]" />

          <div className="grid gap-0 md:grid-cols-2">
            {partners.map((partner, index) => <div key={partner.name} className={`px-8 py-12 text-center md:px-12 ${index === 0 ? "md:border-r md:border-[#D8C29A]" : ""}`}>
                <h3 className="font-serif text-2xl font-bold leading-tight text-[#1C1917]">
                  {partner.name}
                </h3>

                <p className="mt-4 font-mono text-xs font-bold uppercase tracking-[0.24em] text-[#B45309]">
                  {partner.focus}
                </p>

                <div className="mt-6 space-y-1 text-sm leading-relaxed text-[#1C1917]/60">
                  <p>{partner.line1}</p>
                  <p>{partner.line2}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}